/*
* @Author: Abhi Bhatt
* @Date:   2020-06-15 13:31:39
* @Last Modified by:   Abhi Bhatt
* @Last Modified time: 2020-07-17 15:33:03
*/
import axios from 'axios';
import { API_URL } from '../../constants.js';
//import $ from 'jquery';

class HeaderService {
	async getCategory() {
		const url = `${API_URL}/get-header/`;
		const headers = {
			'Content-Type': 'multipart/form-data',
			'Access-Control-Allow-Origin': '*'

		}
		let formData = new FormData();
		return axios({
			url: url,
			method: 'get',
			crossDomain: true,
			data: formData,
			config: { headers: headers },
			//headers: {'Access-Control-Allow-Origin': '*'}
		}).then(function (response) {
			return response;
		}).catch(function (response) {
			return response;
		});
	}

	async getCompanyList(data) {
		const url = `${API_URL}/get-company-list/`;
		const headers = {
			'Content-Type': 'application/json',
			'Access-Control-Allow-Origin': '*'
		}
		return axios({
			url: url,
			method: 'post',
			crossDomain: true,
			data: JSON.stringify(data),
			config: { headers: headers },
		}).then(function (response) {
			return response;
		}).catch(function (response) {
			return response;
		});
	}
}

export default HeaderService;